module.exports = __webpack_public_path__ + "static/media/rouge.9ea8f8bc.png";